import { api } from "@/lib/api";

export async function getExpediereToday() {
  const { data } = await api.get("/expediere/today");
  return data;
}

export async function listExpediereShipments(params = {}) {
  const { data } = await api.get("/expediere/shipments", { params });
  return data;
}

export async function getExpediereStats(days = 14) {
  const { data } = await api.get("/expediere/stats", { params: { days } });
  return data;
}

export async function getExpediereSidebarBadge() {
  const { data } = await api.get("/expediere/sidebar-badge");
  return data;
}

export async function getExpediereSettings() {
  const { data } = await api.get("/expediere/settings");
  return data;
}

export async function updateExpediereSettings(payload) {
  const { data } = await api.put("/expediere/settings", payload);
  return data;
}

export async function getExpediereAvailableTags(limit = 200) {
  const { data } = await api.get("/expediere/available-tags", { params: { limit } });
  return data.items || [];
}
